import { Injectable } from "@angular/core";
import { DialogBoxService } from "@app/custom-shared/components/alerts/dialog-box-service";
import html2canvas from "html2canvas";
import jspdf, { jsPDF } from "jspdf";

export const PDF_WIDTH = 208;
export const PDF_WIDTH_MM = "208mm";

@Injectable({
    providedIn: 'root',
})
export class PdfGenerator {

    constructor(private snackbar: DialogBoxService) { }

    generate(htmlElementId: string, fileName?: string) {

        this.snackbar.snackbarUtil.showInfo("Gerando arquivo PDF, aguarde...");

        let height = window.outerHeight + window.innerHeight;
        let windowHeight = window.outerHeight + window.innerHeight;

        var data = document.getElementById(htmlElementId);
        html2canvas(
            data,
            {
                logging: true,
                allowTaint: false,
                useCORS: true,
                scrollY: -window.scrollY,
                scrollX: 0,
                height: height,
                windowHeight: windowHeight,
                onclone: function (clonedDoc) {
                    clonedDoc.getElementById(htmlElementId).style.visibility = 'visible';
                }
            }).then(canvas => {
                var imgWidth = PDF_WIDTH;
                var imgHeight = (canvas.height * imgWidth) / canvas.width;
                const contentDataURL = canvas.toDataURL('image/png');
                let pdf = new jspdf('p', 'mm', 'a4');
                var position = 0;
                pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
                pdf.save(`${fileName ? fileName : new Date().getTime().toString()}.pdf`);
            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.snackbar.dismissSnackbar();
            });
    }

    template(template: PdfTemplateBase): void {
        try {
            this.snackbar.snackbarUtil.showInfo("Gerando arquivo PDF, aguarde...");
            let pdf = template.builder();
            pdf.save(template.fileName);
        } catch (error) {
            console.error(error);
        } finally {
            this.snackbar.dismissSnackbar();
        }
    }
}

export abstract class PdfTemplateBase implements IPdfTemplate {
    builder(): jspdf {
        throw new Error("A implementação do método builder() do template é obrigatória");
    }
    fileName: string = new Date().getTime().toString();
}
export interface IPdfTemplate {
    builder(): jsPDF;
}

// EXEMPLO: Crie um template estendendo a classe [PdfTemplateBase], implemente o metodo (builder), e informe um nome para o arquivo (fileName)
export class PdfTemplateExemplo extends PdfTemplateBase {
    fileName = "relatorio_padrao";
    builder(): jsPDF {
        let pdf = new jsPDF();
        pdf.text("Relatório padrão - PDF", 10, 10);
        return pdf;
    }
}